import { DeploymentTemplateResponseDto } from "../components/common/ObjectTypes";
import axios from "./axios";

export async function getDeploymentTemplates(): Promise<
  DeploymentTemplateResponseDto[]
> {
  try {
    const resp = await axios.get("/deployment-templates");
    // Format the response data to match our DTO
    // Ensuring ID is always handled as a string to accommodate both integer and UUID formats
    return resp.data.map((template: any) => ({
      id: String(template.id), // Explicitly convert to string
      name: template.name,
      schema_definition: template.schema_definition,
    }));
  } catch (error) {
    console.error("Error fetching deploymentTemplates:", error);
    throw error;
  }
}

export async function getDeploymentTemplateById(
  templateId: string,
): Promise<DeploymentTemplateResponseDto> {
  try {
    const resp = await axios.get(`/deployment-templates/${templateId}`);
    // Format the response data to match our DTO
    return {
      id: String(resp.data.id), // Explicitly convert to string
      name: resp.data.name,
      schema_definition: resp.data.schema_definition,
      ui_schema: resp.data.ui_schema,
    };
  } catch (error) {
    console.error(
      `Error fetching deployment template with ID ${templateId}:`,
      error,
    );
    throw error;
  }
}
